type EnqueueSnackbar = (message: string, options?: Record<string, unknown>) => void;
type SnackbarVariant = "success" | "info" | "error" | "warning" | "default";

export const CustomMessage = (
  message: string | undefined | null,
  type: SnackbarVariant,
  enqueueSnackbar: EnqueueSnackbar
): void => {
  enqueueSnackbar(message ?? "An error occurred", {
    variant: type,
    persist: ["success", "info", "error"].includes(type) ? false : true,
    autoHideDuration: ["success", "info", "error"].includes(type) && 3000,
  });
};

export const ErrorImage = (
  message: string,
  type: SnackbarVariant,
  enqueueSnackbar: EnqueueSnackbar
): void => {
  enqueueSnackbar(message, {
    variant: type,
    persist: true,
    // autoHideDuration: ["success", "info","error"].includes(type) && 3000,
  });
};

export const ErrorTiffImage = (
  message: string,
  type: SnackbarVariant,
  enqueueSnackbar: EnqueueSnackbar
): void => {
  enqueueSnackbar(message, {
    variant: type,
    persist: true,
    // autoHideDuration: ["success", "info","error"].includes(type) && 3000,
  });
};

export const ErrorPdf = (
  message: string,
  type: SnackbarVariant,
  enqueueSnackbar: EnqueueSnackbar
): void => {
  enqueueSnackbar(message, {
    variant: type,
    persist: true,
    // autoHideDuration: ["success", "info","error"].includes(type) && 3000,
  });
};

export const ErrorInvalidFiles = (
  message: string,
  type: SnackbarVariant,
  enqueueSnackbar: EnqueueSnackbar
): void => {
  enqueueSnackbar(message, {
    variant: type,
    persist: true,
    // autoHideDuration: ["success", "info","error"].includes(type) && 3000,
  });
};
